import { Button, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { SearchInput } from 'src/shared/components';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px;

  .ant-input {
    height: 22px;
  }
`;

const FilterButton = styled(Button)`
  width: 100%;
  background-color: var(--main-web-color);
  color: white;

  &:hover,
  :focus {
    background-color: var(--main-web-color-light);
  }
`;

const BOOK_TYPES = [
  {
    label: 'Loại tài liệu: Tất cả',
    value: 'ALL',
  },
  {
    label: 'Giáo trình chính',
    value: 'GTC',
  },
  {
    label: 'Tài liệu tham khảo',
    value: 'TLTK',
  },
  {
    label: 'Tài liệu tham khảo mở rộng',
    value: 'TLTKMR',
  },
];

const DEFAULT_BOOK_TYPE = BOOK_TYPES[0].value;

function OlogyBookFilter({
  onFilter,
  className,
  resetFilter,
  shouldFilterByBookType = true,
  initialSearchKey = '',
}) {
  const [searchValue, setSearchValue] = useState(initialSearchKey);
  const [bookType, setBookType] = useState(DEFAULT_BOOK_TYPE);

  useEffect(() => {
    setSearchValue('');
    setBookType(DEFAULT_BOOK_TYPE);
  }, [resetFilter]);

  useEffect(() => {
    if (!initialSearchKey) {
      return;
    }
    setSearchValue(initialSearchKey);
  }, [initialSearchKey]);

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleBookTypeChange = (value) => {
    setBookType(value);
  };

  const handleSearch = () => {
    onFilter({ searchValue, bookType });
  };

  const handleKeyDown = (e) => {
    if (e.code === 'Enter') {
      onFilter({ searchValue, bookType });
    }
  };

  return (
    <Wrapper className={className} onKeyDown={handleKeyDown}>
      {shouldFilterByBookType && (
        <Select
          value={bookType}
          defaultValue={BOOK_TYPES[0].value}
          onChange={handleBookTypeChange}
        >
          {BOOK_TYPES.map(({ value, label }) => (
            <Select.Option value={value} key={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      )}
      <SearchInput
        value={searchValue}
        onChange={handleSearchChange}
        placeholder="Tìm tài liệu, giáo trình mong muốn ..."
        allowClear
      />
      <FilterButton onClick={handleSearch}>Tìm Kiếm</FilterButton>
    </Wrapper>
  );
}

export default OlogyBookFilter;
